import { Component, OnInit } from '@angular/core';
import { AuthService } from './core/services/auth/auth.service';
import { FcmService } from './core/services/fcm/fcm.service';
import { UserStateService } from './core/services/user/user-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'eldib-dashboard';
  message;
  constructor(private messagingService: FcmService, private authService: AuthService, private userState: UserStateService) { }
  onActivate(event) {
    window.scroll(0, 0);
  }

  ngOnInit() {
    if (this.authService.isAuthenticated() && !localStorage.getItem('browserRegistered')) {
      this.messagingService.requestPermission();
      this.messagingService.receiveMessage();
      this.message = this.messagingService.currentMessage;
    }
  }
}
